module.exports = __webpack_public_path__ + "img/viajes.111576d5.jpg";